export default "__VITE_ASSET__BeMicVJl__"